import { render, staticRenderFns } from "./NflSummary.vue?vue&type=template&id=442896a6&scoped=true"
import script from "./NflSummary.vue?vue&type=script&lang=js"
export * from "./NflSummary.vue?vue&type=script&lang=js"
import style0 from "./NflSummary.vue?vue&type=style&index=0&id=442896a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442896a6",
  null
  
)

export default component.exports